export const videosApi = process.env.REACT_APP_API_URL_VIDEOS ?? "";
export const viewVideos = process.env.REACT_APP_API_URL_VIEW ?? "";
